'use client';

import { useTheme } from 'next-themes';
import { useEffect } from 'react';

const ONE_YEAR_SECONDS = 60 * 60 * 24 * 365;

function setCookie(name: string, value: string) {
  try {
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; max-age=${ONE_YEAR_SECONDS}; samesite=lax`;
  } catch {}
}

export default function ThemeCookieSync() {
  const { theme, resolvedTheme } = useTheme();

  useEffect(() => {
    const mode = String(theme ?? '').trim().toLowerCase();
    const resolved = String(resolvedTheme ?? '').trim().toLowerCase();

    if (mode === 'light' || mode === 'dark' || mode === 'system') {
      setCookie('theme_mode', mode);
    }
    if (resolved === 'light' || resolved === 'dark') {
      setCookie('theme_resolved', resolved);
    }
  }, [resolvedTheme, theme]);

  return null;
}

